"use client";
import { AxiomJSTransport, Logger } from "@axiomhq/logging";
import { nextJsFormatters } from "@axiomhq/nextjs/client";
import { createUseLogger, createWebVitalsComponent } from "@axiomhq/react";
import axiomClient from "./axiom";

const logger = new Logger({
	transports: [new AxiomJSTransport({ axiom: axiomClient, dataset: "next-settlin"! })],
	formatters: nextJsFormatters,
});

const useLogger = createUseLogger(logger);
const WebVitals = createWebVitalsComponent(logger);

export { WebVitals };

export const _useLogger = useLogger;
